import React from 'react';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';
import MessageButton from 'buyside/components/presentation/MessageModal/messageButton';
import ProfileImage, {
  IMAGE_SIZES
} from 'buyside/components/presentation/ProfileImage/profileImage';

import { AccreditedInvestorProfileIndexItemFragment } from 'interfaces/graphql-typings';

import styles from './accreditedInvestorProfileIndexItemStyles.scss';

import { defaultUserImageUrl, userUrl } from 'buyside/util/urlHelper';
import { truncateText } from 'buyside/util/textHelpers';

const AccreditedInvestorProfileIndexItem: React.FC<{
  canViewUserDetails: boolean;
  node: AccreditedInvestorProfileIndexItemFragment;
}> = ({
  canViewUserDetails,
  node: {
    user: { displayName, id, profileCity, profileImageUrl, profile }
  }
}) => (
  <div className={styles.accreditedInvestorIndexItem}>
    <div className={styles.itemHeader}>
      <div className={styles.headerInfo}>
        <ProfileImage
          className={styles.profileImage}
          source={canViewUserDetails ? profileImageUrl : defaultUserImageUrl()}
          size={IMAGE_SIZES.SMALLER}
        />
        <div>
          <div className={styles.investorName}>
            {canViewUserDetails ? (
              <Link to={userUrl(id)}>
                <h4>{displayName}</h4>
              </Link>
            ) : (
              <h4>SumZero Member</h4>
            )}
          </div>
          <div>{profileCity}</div>
        </div>
      </div>
      <div className={styles.headerActions}>
        <MessageButton
          receiverId={id}
          receiverName={displayName}
          showUpsell
          buttonOptions={{
            text: 'Message',
            type: BUTTON_TYPES.LINK,
            size: BUTTON_SIZES.SMALL,
            faIcon: faEnvelope
          }}
        />
        {canViewUserDetails && (
          <Button
            size={BUTTON_SIZES.SMALL}
            text="View Details"
            type={BUTTON_TYPES.LINK}
            url={userUrl(id)}
          />
        )}
      </div>
    </div>
    {profile?.summary && (
      <>
        <br />
        <div className={styles.bio}>{truncateText(profile?.summary, 100)}</div>
      </>
    )}
  </div>
);

export default AccreditedInvestorProfileIndexItem;
